export const MAINTENANCE_EVENT = 'vloggi:maintenance'

export type MaintenanceDetails = {
  maintenance: boolean
  code?: string
  message?: string
  expectedEndAt?: string | null
  retryAfterSeconds?: number
}

export const isMaintenanceResponse = (error: any): boolean =>
  error?.response?.status === 503 &&
  (error?.response?.data?.maintenance === true || error?.response?.data?.code === 'MAINTENANCE_MODE')

export const announceMaintenance = (details: MaintenanceDetails = { maintenance: true }): void => {
  window.dispatchEvent(new CustomEvent(MAINTENANCE_EVENT, { detail: details }))
}
